import styleInject from '../../util/injectCss.js';

var css_248z = ".DateRangeFilter__XecvX_v2-52-0 {\n  width: 100%;\n}";
var styles = {"DateRangeFilter":"DateRangeFilter__XecvX_v2-52-0"};
styleInject(css_248z);

export { styles as default };
